"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTerritoryValueProvider = useTerritoryValueProvider;
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const classifiers_1 = require("../../classifiers");
function useTerritoryValueProvider(params) {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (0, classifiers_1.buildPublicDataValueProvider)({
        label: t('defaultClassifiers.territory'),
        ...params,
        classifierName: 'territory',
    });
}
